module.exports = __webpack_public_path__ + "img/terminal-browser.ac1bc9ab.svg";